/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'confluence.error.panel.refresh.app': 'Odśwież aplikację',
  'confluence.error.panel.reload.page': 'Załaduj stronę ponownie',
  'confluence.icon.label': 'Ikona',
  'confluence.modal.dialog.close.modal.button': 'Anuluj',
  'confluence.select.required.field.message': 'To pole jest wymagane.',
  'confluence.text.area.required.field.message': 'To pole jest wymagane.',
  'confluence.textfield.validator.email': 'Wprowadź prawidłowy adres e-mail.',
  'confluence.textfield.validator.number': 'Wpisz prawidłową liczbę',
  'confluence.textfield.validator.required.field.message': 'To pole jest wymagane.',
  'confluence.textfield.validator.telephone': 'Wprowadź prawidłowy numer telefonu.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Wymagany dostęp',
  'confluence.threeLOPrompt.modal.error.title': 'Błąd',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Nie znaleziono adresu URL zgody. Odśwież stronę i spróbuj ponownie.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Nie znaleziono adresu URL zgody. Odśwież stronę i spróbuj ponownie.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Przyznaj dostęp',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Skonfiguruj dostęp',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Nie można uwierzytelnić.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Aby móc wyświetlić {appString}, musisz zezwolić aplikacji na dostęp do produktów Atlassian w Twoim imieniu.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} wymaga dodatkowego dostępu do Twojego konta.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Ostrzeżenie o uwierzytelnianiu z zewnątrz',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'Ta aplikacja',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Ta aplikacja',
  'confluence.user.group.unknown.user.message': 'Nieznany użytkownik',
  'confluence.user.picker.empty.field.error.message': 'To pole jest wymagane.',
  'confluence.user.unknown.user.message': 'Nieznany użytkownik',
  'forge-ui.form.submit-button.text': 'Wyślij',
};
